<template lang="html">
  <div>
    <v-form
      class="overflow"
      data-simplebar
    >
      <v-container>
        <v-alert
          :value="existed"
          color="indigo"
          icon="info"
          transition="scale-transition"
        >
          <v-row>
            <v-col 
              class="white--text"
              cols="10"
            >
              Are you trying to create new account for <span class="title">{{ existedPerson.name }}</span>?
            </v-col>
            <v-col cols="1">       
              <v-btn
                small
                rounded
                color="error"
                @click="existed = false;checkIc = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn
                :loading="progressing"
                small
                rounded
                color="success"
                @click="hasEmployee"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-alert
          :value="!checkIc"
          type="info"
          color="primary"
          transition="scale-transition"
        >
          Please key in the IC number first
        </v-alert>
        <v-alert
          :value="contactAdmin"
          type="error"
          dismissible
          icon="warning"
          transition="scale-transition"
        >
          Failed to create. Please contact administator for further assistance
        </v-alert>
        <v-alert
          :value="newPerson"
          type="success"
          dismissible
          transition="scale-transition"
        >
          You may create new account with this IC
        </v-alert>
        <v-alert
          :value="personWithoutEmployee()"
          type="info"
          dismissible
          color="primary"
          transition="scale-transition"
        >
          Please fill the remaining active fields below
        </v-alert>
        <v-row>
          <v-col 
            cols="12" 
            class="py-0"
            md="6"
          >
            <v-text-field
              ref="focus"
              v-model="form.ic_number"
              v-validate="'required|icDate|icLength'"
              v-mask="mask"
              :disabled="existed || personWithoutEmployee()"
              :error-messages="errors.collect('identity.ic_number')"
              data-vv-name="identity.ic_number"
              data-vv-as="ic number"
              label="IC Number"
              @input="getBirthdayFromIC(form.ic_number);icValidation(form.ic_number)"
            />
          </v-col>

          <v-col 
            cols="12" 
            class="py-0"
            md="6"
          >
            <v-text-field            
              v-model="form.name"
              v-validate="'required|max:255'"
              :disabled="!checkIc || !newPerson"
              :filled="!checkIc || !newPerson"
              :error-messages="errors.collect('person.name')"
              data-vv-name="person.name"
              data-vv-as="name"
              label="Name"
            />
          </v-col>
        </v-row>
        <div v-if="newPerson">
          <v-row>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.title"
                v-validate="'required'"
                :disabled="!checkIc || !newPerson"
                :error-messages="errors.collect('person.title_lookup_uid')"
                :items="title"
                :filled="!checkIc || !newPerson"
                data-vv-name="person.title_lookup_uid"     
                data-vv-as="title"            
                item-text="value"
                item-value="lookup_uid"
                label="Title"
              />
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.gender"
                v-validate="'required'"
                :disabled="!checkIc || !newPerson"
                :error-messages="errors.collect('person.gender_lookup_uid')"
                :items="gender"
                :filled="!checkIc || !newPerson"
                data-vv-name="person.gender_lookup_uid"
                data-vv-as="gender"
                item-text="value"
                item-value="lookup_uid"
                label="Gender"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.ethnicity"
                v-validate="'required'"
                :error-messages="errors.collect('person.ethnicity_lookup_uid')"
                :items="ethnicity"
                :disabled="!checkIc || !newPerson"
                :filled="!checkIc || !newPerson"
                data-vv-name="person.ethnicity_lookup_uid"
                data-vv-as="ethnicity"
                item-text="value"
                item-value="lookup_uid"
                label="Ethnicity"
              />
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.religion"
                v-validate="'required'"
                :error-messages="errors.collect('person.religion_lookup_uid')"
                :items="religion"
                :disabled="!checkIc || !newPerson"
                :filled="!checkIc || !newPerson"
                data-vv-name="person.religion_lookup_uid"
                data-vv-as="religion"
                item-text="value"
                item-value="lookup_uid"
                label="Religion"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-menu
                v-model="datepicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
                disabled
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="displayDate"
                    label="Birthday"
                    prepend-inner-icon="event"
                    readonly
                    filled
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="form.birthday"
                  class="datepicker"
                  disabled
                  @input="datepicker = false"
                />
              </v-menu>
            </v-col>

            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.place_of_birth"
                v-validate="'required'"
                :error-messages="errors.collect('person.dob_state_lookup_uid')"
                :items="place_of_birth"
                :disabled="!checkIc || !newPerson"
                :filled="!checkIc || !newPerson"
                data-vv-name="person.dob_state_lookup_uid"
                data-vv-as="place of birth"         
                item-text="value"
                item-value="lookup_uid"
                label="Place of Birth"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <v-autocomplete
                v-model="form.marital_status"
                v-validate="'required'"
                :error-messages="errors.collect('person.marital_status_lookup_uid')"
                :items="marital_status"
                :disabled="!checkIc || !newPerson"
                :filled="!checkIc || !newPerson"
                data-vv-name="person.marital_status_lookup_uid"   
                data-vv-as="marital status"
                item-text="value"
                item-value="lookup_uid"
                label="Marital Status"
              />
            </v-col>

            <v-col
              lg="6"
              class="py-0"
            >
              <v-text-field
                v-model="form.dependents"
                v-validate="'required|dependentsValue'"
                :error-messages="errors.collect('dependents')"
                :disabled="!checkIc || !newPerson"
                :filled="!checkIc || !newPerson"
                data-vv-name="dependents"
                type="number"
                label="Dependents"
              />
            </v-col>
          </v-row>
          <!-- Add -->
          <v-row>
            <v-col 
              cols="12" 
              md="6"
              class="py-0"
            >
              <div>
                <v-row>
                  <v-col style="padding-top: 0px">
                    <v-text-field
                      v-model="addressLine1"
                      v-validate="'required'"
                      :error-messages="errors.collect('addressLine1')"
                      :disabled="!checkIc || !newEmployee"
                      :filled="!checkIc || !newEmployee"
                      data-vv-name="addressLine1"
                      data-vv-as="address line  1"
                      label="Correspondence Address 1"
                      @input="addressLine1 = addressLine1.toUpperCase()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="padding-top: 0px">
                    <v-text-field
                      v-model="addressLine2"
                      :error-messages="errors.collect('addressLine2')"
                      :disabled="!checkIc || !newEmployee"
                      :filled="!checkIc || !newEmployee"
                      data-vv-name="addressLine2"
                      label="Correspondence Address 2"
                      @input="addressLine2 = addressLine2.toUpperCase()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="padding-top: 0px">
                    <v-text-field
                      v-model="addressLine3"
                      :error-messages="errors.collect('addressLine3')"
                      :disabled="!checkIc || !newEmployee"
                      :filled="!checkIc || !newEmployee"
                      data-vv-name="addressLine3"
                      label="Correspondence Address 3"
                      @input="addressLine3 = addressLine3.toUpperCase()"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12" 
                    md="3"
                    class="py-0"
                  >
                    <v-autocomplete
                      v-model="postcode"
                      v-validate="'required'"
                      :items="postcodes"
                      :error-messages="errors.collect('postcodeId')"
                      :disabled="!checkIc || !newEmployee || !addressLine1"
                      :filled="!checkIc || !newEmployee"
                      data-vv-name="postcodeId"
                      data-vv-as="postcode" 
                      item-text="postcode"
                      item-value="postcode"
                      value="postcode"
                      label="Postcode"
                      hide-selected
                      @input="postCodeOnChanged(postcode)"
                    />
                  </v-col>
                  <v-col
                    lg="3"
                    class="py-0"
                  >
                    <v-autocomplete
                      v-show="postcode"
                      v-model="cityId"
                      v-validate="'required'"
                      :items="filteredCities"
                      :error-messages="errors.collect('cityId')"
                      :filled="!checkIc || !newEmployee"
                      :disabled="dropdownDisabled"
                      data-vv-name="cityId"
                      data-vv-as="city" 
                      item-text="name"
                      item-value="id"
                      value="id"
                      label="City"
                      hide-selected
                      @input="cityOnChanged(cityId)"
                    />
                  </v-col>
                  <v-col
                    lg="3"
                    class="py-0"
                  >
                    <v-autocomplete
                      v-show="cityId"
                      v-model="stateId"
                      v-validate="'required'"
                      disabled
                      :items="states"
                      :error-messages="errors.collect('stateId')"
                      :filled="!checkIc || !newEmployee"
                      data-vv-name="stateId"
                      item-text="name"
                      item-value="id"
                      value="id"
                      label="State"
                      hide-selected
                    />
                  </v-col>
                  <v-col
                    lg="3"
                    class="py-0"
                  >
                    <v-autocomplete
                      v-show="stateId"
                      v-model="countryId"
                      v-validate="'required'"
                      disabled
                      :items="countries"
                      :error-messages="errors.collect('countryId')"
                      :filled="!checkIc || !newEmployee"
                      data-vv-name="countryId"
                      item-text="name"
                      item-value="id"
                      value="id"
                      label="Country"
                      hide-selected
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>

            <v-col 
              cols="6"
              class="py-0"
            >
              <div>
                <v-row>
                  <v-col style="padding-top: 0px">
                    <v-text-field
                      v-model="mobilephoneNumber"
                      v-validate="'required|phoneLength'"
                      v-mask="['###-###-####', '###-####-####']"
                      :error-messages="errors.collect('mobilephoneNumber')"
                      :disabled="!checkIc || !newEmployee"
                      :filled="!checkIc || !newEmployee"
                      data-vv-name="mobilephoneNumber"
                      data-vv-as="mobile phone"
                      label="Mobile Phone No."
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="padding-top: 0px">
                    <v-text-field            
                      v-model="email"
                      v-validate="'required|email'"
                      :disabled="!checkIc || !newPerson"
                      :filled="!checkIc || !newPerson"
                      :error-messages="errors.collect('email')"
                      data-vv-name="email"
                      data-vv-as="email"
                      label="Email"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col style="padding-top: 0px">
                    <v-menu
                      id="date"
                      v-model="startmenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="joinDateDisplay"
                          :disabled="!checkIc || !newEmployee"
                          :filled="!checkIc || !newEmployee"
                          label="Join Date"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="joinDate"
                        class="datepicker"
                        no-title
                        @input="startmenu = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="department"
              v-validate="'required'"
              :error-messages="errors.collect('employee.department_id')"
              :items="departments"
              :disabled="!checkIc || !newEmployee"
              :filled="!checkIc || !newEmployee"
              data-vv-name="employee.department_id"
              data-vv-as="department"   
              item-text="name"
              item-value="id"
              value="id"
              label="Department"
            />
          </v-col>
          <v-col
            cols="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="selectedPosition"
              v-validate="'required'"
              :items="positions"
              :error-messages="errors.collect('position')"
              data-vv-name="position"
              label="Position"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              return-object
              :disabled="!checkIc || !newEmployee"
              :filled="!checkIc || !newEmployee"
            />  
          </v-col>
        </v-row>
        <v-row>          
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="state"
              v-validate="'required'"
              :items="states"
              :error-messages="errors.collect('state')"
              :disabled="!checkIc || !newEmployee"
              :filled="!checkIc || !newEmployee"
              data-vv-name="state"
              item-text="name"
              item-value="id"
              value="id"
              label="State of Work"
              hide-selected
            />
          </v-col>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-show="state"
              v-model="city"
              v-validate="'required'"
              :items="cityList"
              :error-messages="errors.collect('employee.city_id')"
              :disabled="!checkIc || !newEmployee"
              :filled="!checkIc || !newEmployee"
              data-vv-name="employee.city_id"
              data-vv-as="city" 
              item-text="name"
              item-value="id"
              value="id"
              label="City of Work"
              hide-selected
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col 
            cols="12" 
            md="6"
            class="py-0"
          >
            <v-autocomplete
              v-model="workSessionType"
              v-validate="'required'"
              :items="workSessionTypes"
              :error-messages="errors.collect('workDays')"
              :disabled="!checkIc || !newEmployee"
              :filled="!checkIc || !newEmployee"
              data-vv-name="workDays"
              data-vv-as="work day"
              item-text="name"
              item-value="id"
              value="id"
              label="Work Days"
              hide-selected
              @change="workDaysDisplay"
            />
          </v-col>
        </v-row>

        <v-row v-show="workSessionType">
          <v-col>
            <div class="font-weight-black">
              <span> Workday Session </span>
              <v-radio-group
                v-model="defaultSet"
                v-validate="'required'"
                :disabled="!checkIc || !newEmployee"
                :error-messages="errors.collect('workday')"
                data-vv-name="workday"
                data-vv-as="workday session template"
              >
                <v-radio
                  label="Default"
                  :value="true"
                />
                <v-radio
                  label="Customized"
                  :value="false"
                />
              </v-radio-group>
            </div>
          </v-col>
        </v-row>
        <v-row v-show="workSessionType">
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Monday Session"
              disabled
              :value="formSession.monSession"
              :filled="!checkIc || !newEmployee"
            />
          </v-col>
          <!-- <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.monLeaveSession"
              :items="leaveSessions"
              :disabled="defaultSet"
              :filled="!checkIc || !newEmployee"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col> -->
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.monIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Tuesday Session"
              disabled
              :value="formSession.tueSession"
              :filled="!checkIc || !newEmployee"
            />
          </v-col>
          <!-- <v-col
            cols="12"
            class="py-0" 
            md="2"
          >
            <v-autocomplete
              v-model="formSession.tueLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc || !newEmployee"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col> -->
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.tueIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Wednesday Session"
              disabled
              :value="formSession.wedSession"
              :filled="!checkIc || !newEmployee"
            />
          </v-col>
          <!-- <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.wedLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc || !newEmployee"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col> -->
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.wedIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Thursday Session"
              disabled
              :value="formSession.thuSession"
              :filled="!checkIc || !newEmployee"
            />
          </v-col>
          <!-- <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.thuLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc || !newEmployee"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col> -->
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.thuIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Friday Session"
              disabled
              :value="formSession.friSession"
              :filled="!checkIc || !newEmployee"
            />
          </v-col>
          <!-- <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.friLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc || !newEmployee"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col> -->
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.friIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Saturday Session"
              disabled
              :value="formSession.satSession"
              :filled="!checkIc || !newEmployee"
            />
          </v-col>
          <!-- <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.satLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc || !newEmployee"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col> -->
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.satIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-text-field
              label="Sunday Session"
              disabled
              :value="formSession.sunSession"
              :filled="!checkIc || !newEmployee"
            />
          </v-col>
          <!-- <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-autocomplete
              v-model="formSession.sunLeaveSession"
              :disabled="defaultSet"
              :items="leaveSessions"
              :filled="!checkIc || !newEmployee"
              label="Leave Session"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col> -->
          <v-col
            cols="12" 
            md="2"
            class="py-0"
          >
            <v-checkbox
              v-model="formSession.sunIsPayrollFullday"
              label="Is Payroll Fullday?"
              color="success"
              hide-details
              :disabled="defaultSet"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!checkIc"
            :loading="progressing"
            color="success"
            @click="submitForm"
          >
            Create Employee
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    inject: ['$validator'],
    data () {
      return {
        leaveSessions: [],
        checkIc: false,
        contactAdmin: false,
        defaultSet: true,
        existed: false,
        mask: '######-##-####',
        progressing: false,
        // positions
        positions: [],
        categories: [],
        selectedPosition: null,
        // employee
        city: '',
        cities: [],
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        postcode: '',
        postcodes: [],
        cityId: null,
        stateId: null,
        countryId: null,
        countries: [],
        mobilephoneNumber: null,
        cityIds: [],
        department: '',
        departments: [],
        joinDate: this.$moment().format('YYYY-MM-DD'),     
        newEmployee: false,
        startmenu: false,
        state: '',
        states: [],
        workSessions: [],
        email: null,
        workSessionTypes: [],
        workSessionType: null,
        // person
        datepicker: false,
        existedPerson: {},     
        form: {
          title: '',
          gender: '',
          name: '',
          ethnicity: '',
          ic_number: '',
          religion: '',        
          marital_status: '',
          place_of_birth: '',
          birthday: '',
          dependents: 0,
        },
        newPerson: false,
        formSession: {
          monSession: '',
          tueSession: '',
          wedSession: '',
          thuSession: '',
          friSession: '',
          satSession: '',
          sunSession: '',

          monLeaveSession: 1,
          tueLeaveSession: 1,
          wedLeaveSession: 1,
          thuLeaveSession: 1,
          friLeaveSession: 1,
          satLeaveSession: 4,
          sunLeaveSession: 1,

          monIsPayrollFullday: 1,
          tueIsPayrollFullday: 1,
          wedIsPayrollFullday: 1,
          thuIsPayrollFullday: 1,
          friIsPayrollFullday: 1,
          satIsPayrollFullday: 1,
          sunIsPayrollFullday: 0,
        },
        dropdownDisabled: null,
      }
    },
    computed: {
      ...mapState('lookup', ['title', 'gender', 'ethnicity', 'religion', 'marital_status', 'place_of_birth']),
      departmentDisplay () {
        return this.departments
      },
      cityList () {
        return this.cities.filter(city => {
          if (this.state) {
            return city.state_id === this.state
          }
          return city
        })
      },
      displayDate () {
        return this.form.birthday ? this.$moment(this.form.birthday).format('D MMM YYYY') : ''
      },
      joinDateDisplay () {
        return this.joinDate ? this.$moment(this.joinDate, 'YYYY-MM-DD').format('D MMM YYYY') : ''
      },
      sortedRanks () {
        return _.sortBy(this.ranks, 'value')
      },
      ranks () {
        if (!this.selectedPosition) return 

        return ((this.categories.find(category => {
          return category.id === this.selectedPosition.position_category_id
        }) || {}).ranks || [])
      },
      selectedWorkSessionType () {
        if (!this.workSessionType) return
        return this.workSessionTypes.find(workSessionType => { return workSessionType.id === this.workSessionType })
      },
      filteredCities () {
        return this.cities.filter(city => {
          return this.cityIds.includes(city.id)
        })         
      },
    },
    mounted () {
      this.$nextTick(this.$refs.focus.focus)
      let scope = this

      this.$validator.extend('dependentsValue', {
        getMessage (field, args) {
          return 'Invalid Number of Dependents'
        },
        validate (value, args) {
          return scope.isValidDependents(value)
        },
      })
      this.$validator.extend('icDate', {
        getMessage (field, args) {
          return 'Invalid IC Date'        
        },
        validate (value, args) {
          return scope.isValidDate(value) 
        },
      })
      this.$validator.extend('icLength', {
        getMessage (field, args) {
          return 'IC not in right length'        
        },
        validate (value, args) {
          return value.toString().length === 12
        },
      })
      this.$validator.extend('phoneLength', {
        getMessage (field, args) {
          return 'Invalid phone number (at least 10 numbers and max 11)'
        },
        validate (value, args) {
          return value.toString().length >= 12 && value.toString().length < 14
        },
      })
    },
    methods: {
      employeeFormData () {
        return {
          city_id: this.city,
          department_id: this.department,
          joined_date: this.joinDate,
          person_uid: this.existedPerson.person_uid,
        }
      },
      hasEmployee () {
        this.setProgressing(true)
        this.existed = false
        this.contactAdmin = false
        this.$api.employees().show(this.existedPerson.person_uid)
          .then((res) => {
            this.contactAdmin = true
          })
          .catch(() => {
            this.form.name = this.existedPerson.name
            this.form.title = this.existedPerson.title_lookup_uid
            this.form.gender = this.existedPerson.gender_lookup_uid
            this.form.ethnicity = this.existedPerson.ethnicity_lookup_uid
            this.form.religion = this.existedPerson.religion_lookup_uid
            this.form.marital_status = this.existedPerson.marital_status_lookup_uid
            this.form.dependents = this.existedPerson.no_of_dependent
            this.form.place_of_birth = this.existedPerson.dob_state_lookup_uid
            this.newEmployee = true
            this.checkIc = true
          })
          .then(() => {
            this.setProgressing(false)
          })
      },
      icValidation (value) {
        if (value.toString().length === 14) {
          this.form.ic_number = this.form.ic_number.replace(/-/g, '')
          this.$validator.validate('identity.ic_number', this.form.ic_number)
            .then(result => {
              if (!result) return
              this.loadPostcode()
              this.loadCity()
              this.loadCountry()
              this.loadDepartment()
              this.loadState()
              this.loadWorkSessionType()
              // this.loadLeaveSession()
              this.loadPosition()
              this.loadPositionCategory()
              this.$api.identityCards().showPerson(this.form.ic_number)
                .then((res) => {
                  this.checkIc = true
                  this.existedPerson = res.data
                  this.existed = true
                })
                .catch(() => {
                  this.checkIc = true
                  this.newPerson = true
                  this.newEmployee = true
                })
            })
        } else {
          this.$resetData()
        }
      },
      loadCity () {
        this.$api.cities().list()
          .then((res) => {
            this.cities = res.data
          })
          .catch(() => {})
      },
      loadDepartment () {
        this.$api.departments().list(['name'], false)
          .then((res) => {
            this.departments = res.data
          })
          .catch(() => {})
      },
      loadState () {
        this.$api.states().list()
          .then((res) => {
            this.states = res.data
          })
          .catch(() => {})
      },
      loadWorkSessionType () {
        this.$api.workSessionTypes().list('?filter[is_active]=true')
          .then((res) => {
            this.workSessionTypes = res.data
          })
          .catch(() => {})
      },
      loadLeaveSession () {
        this.$api.leaveSessions().list()
          .then((res) => {
            this.leaveSessions = res.data

            res.data.forEach(item => {
              if (item.name === 'None') {
                item.name = 'No Restriction'
              } else if (item.name === 'A.M') {
                item.name = 'A.M only'
              } else if (item.name === 'P.M') {
                item.name = 'P.M only'
              } else {
                item.name = 'Full Day'
              }
            })
          })
          .catch(() => {})
      },
      loadPosition () {
        this.$api.positions().list()
          .then((res) => {
            this.positions = res.data
          })
      },
      loadPositionCategory () {
        this.$api.positionCategories().list(['ranks'])
          .then((res) => {
            this.categories = res.data
          })
      },
      loadPostcode () {
        this.$api.postcodes().list()
          .then((res) => {
            this.postcodes = res.data
          })
          .catch(() => {})
      },
      loadCountry () {
        this.$api.countries().list()
          .then((res) => {
            this.countries = res.data
          })
          .catch(() => {})
      },
      postCodeOnChanged (postcodeValue) {
        this.cityId = null
        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city => {
          return cityID.some(city2 => {
            return city2.city_id === city.id
          })
        }).map(city3 => {
          return city3.id
        })

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true

          var cityId = this.postcodes.find(postcode => {
            return postcode.postcode === postcodeValue
          }).city_id

          if (cityId) {
            var cityObject = this.cities.find(city => {
              return city.id === cityId
            })
            this.cityId = cityObject.id

            if (cityObject) {
              var stateObject = this.states.find(state => {
                return state.id === cityObject.state_id
              })
              this.stateId = stateObject.id

              if (stateObject) {
                var countryObject = this.states.find(state => {
                  return state.country_id === stateObject.country_id
                })
                this.countryId = countryObject.id
              }
            }
          }          
        }
      },
      cityOnChanged (cityId) {
        var cityObj = this.cities.find(city => {
          return city.id === cityId
        })

        if (cityObj) {
          var stateObj = this.states.find(state => {
            return state.id === cityObj.state_id
          })
          this.stateId = stateObj.id

          if (stateObj) {
            var countryObject = this.states.find(state => {
              return state.country_id === stateObj.country_id
            })
            this.countryId = countryObject.id
          }
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)
            if (!this.personWithoutEmployee()) {
              this.$api.employees().createEmployeePerson(this.prepareFormData())
                .then((res) => {
                  if (res.status === 201) {
                    this.createEmployeeEssentials(res.data.employee.employee_uid, res.data.person.person_uid, res.data.person.name)        
                  }
                })
                .catch(() => {})
                .then(() => {
                  this.setProgressing(false)
                })
            } else {
              this.$api.employees().create(this.employeeFormData())
                .then((res) => {
                  if (res.status === 201) {
                    this.createEmployeeEssentials(res.data.employee.employee_uid, this.existedPerson.person_uid, this.existedPerson.name)
                  }                         
                })
                .catch(() => {})
                .then(() => {
                  this.setProgressing(false)
                })
            }
          })
      },
      prepareFormData () {
        return {
          employee: {
            joined_date: this.joinDate,
            department_id: this.department,
            city_id: this.city,
            mobilephone_number: this.mobilephoneNumber,
            address_line_1: this.addressLine1,
            address_line_2: this.addressLine2,
            address_line_3: this.addressLine3,
            postcode: this.postcode,
            address_city_id: this.cityId,
            address_state_id: this.stateId,
            address_country_id: this.countryId,
            email: this.email,
          },
          person: {
            title_lookup_uid: this.form.title,
            gender_lookup_uid: this.form.gender,
            name: this.form.name,
            ethnicity_lookup_uid: this.form.ethnicity,
            religion_lookup_uid: this.form.religion,
            marital_status_lookup_uid: this.form.marital_status,
            dob_state_lookup_uid: this.form.place_of_birth,
            no_of_dependent: this.form.dependents,          
            dob: this.$moment(this.form.birthday).format('YYYY-MM-DD HH:mm:ss'),
          },
          identity: {
            ic_number: this.form.ic_number,
          },
        }
      },
      prepareWorkdayForm () {
        return [
          {
            day: 1,
            work_session_id: this.selectedWorkSessionType.work_sessions[0].id,
            leave_session_id: this.formSession.monLeaveSession,
            is_payroll_fullday: this.formSession.monIsPayrollFullday,
          },
          {
            day: 2,
            work_session_id: this.selectedWorkSessionType.work_sessions[1].id,
            leave_session_id: this.formSession.tueLeaveSession,
            is_payroll_fullday: this.formSession.tueIsPayrollFullday,
          },
          {
            day: 3,
            work_session_id: this.selectedWorkSessionType.work_sessions[2].id,
            leave_session_id: this.formSession.wedLeaveSession,
            is_payroll_fullday: this.formSession.wedIsPayrollFullday,
          },
          {
            day: 4,
            work_session_id: this.selectedWorkSessionType.work_sessions[3].id,
            leave_session_id: this.formSession.thuLeaveSession,
            is_payroll_fullday: this.formSession.thuIsPayrollFullday,
          },
          {
            day: 5,
            work_session_id: this.selectedWorkSessionType.work_sessions[4].id,
            leave_session_id: this.formSession.friLeaveSession,
            is_payroll_fullday: this.formSession.friIsPayrollFullday,
          },
          {
            day: 6,
            work_session_id: this.selectedWorkSessionType.work_sessions[5].id,
            leave_session_id: this.formSession.satLeaveSession,
            is_payroll_fullday: this.formSession.satIsPayrollFullday,
          },
          {
            day: 7,
            work_session_id: this.selectedWorkSessionType.work_sessions[6].id,
            leave_session_id: this.formSession.sunLeaveSession,
            is_payroll_fullday: this.formSession.sunIsPayrollFullday,
          },
        ]
      },
      personWithoutEmployee () {
        if (!this.newPerson && this.newEmployee) { return true } else { return false }
      },
      getBirthdayFromIC (value) {
        if (value !== null || value !== '') {
          if (this.isValidDate(value)) {
            var date = value.substr(0, 6)
            if (Number(date.substr(0, 2)) >= 48) {
              this.form.birthday = new Date('19' + date.substr(0, 2) + '-' + date.substr(2, 2) + '-' + date.substr(4, 2))
            } else {
              let dob = new Date('20' + date.substr(0, 2) + '-' + date.substr(2, 2) + '-' + date.substr(4, 2))
              let inFuture = new Date() < dob
              while (inFuture) {
                dob.setFullYear(dob.getFullYear() - 100)
                inFuture = new Date() < dob
              }
              this.form.birthday = dob
            }
          } else {
            this.form.birthday = null
          }
        } else {
          this.form.birthday = null
        }
      },
      isValidDate (value) {
        var y = parseInt(value.substr(0, 2))
        var m = parseInt(value.substr(2, 2))
        var d = parseInt(value.substr(4, 2))
        if (m === 0 || m > 12) { return false }
        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]
        // Adjust for leap years
        if (y % 400 === 0 || (y % 100 !== 0 && y % 4 === 0)) { monthLength[1] = 29 }
        return d > 0 && d <= monthLength[m - 1]
      },
      isValidDependents (value) {
        return value >= 0
      },
      setProgressing (status) {
        this.progressing = status
      },
      preparePositionForm () {
        let formData = new FormData()

        formData.append('position_id', this.selectedPosition.id)
        // formData.append('position_category_rank_id', this.sortedRanks[0].pivot.id)
        formData.append('create_leave', false)

        return formData
      },
      createEmployeeEssentials (employeeUid, personUid, personName) {
        Promise.all([
          this.$api.employeeWorkdays().create(employeeUid, this.prepareWorkdayForm()),
          this.$api.employeePositions().create(employeeUid, this.preparePositionForm()),
          this.$api.employees().updateEmail(employeeUid, { email: this.email }),
        ])
          .then(([employeeWorkDay, employeePosition]) => {
            if (employeeWorkDay.status === 200) {  
              this.$emit('created', employeeUid, personUid, personName)
            }
          })
          .catch(() => {})
          .then(() => {
            this.setProgressing(false)
          })         
      },
      workDaysDisplay () {
        let workSession = this.workSessionTypes.find(workSessionType => { return workSessionType.id === this.selectedWorkSessionType.id })

        this.formSession.monSession = this.$moment(workSession.work_sessions[0].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[0].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.tueSession = this.$moment(workSession.work_sessions[1].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[1].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.wedSession = this.$moment(workSession.work_sessions[2].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[2].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.thuSession = this.$moment(workSession.work_sessions[3].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[3].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.friSession = this.$moment(workSession.work_sessions[4].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[4].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.satSession = this.$moment(workSession.work_sessions[5].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[5].end_time, 'hh:mm').format('hh:mm A')
        this.formSession.sunSession = this.$moment(workSession.work_sessions[6].start_time, 'hh:mm').format('hh:mm A') + ' - ' + this.$moment(workSession.work_sessions[6].end_time, 'hh:mm').format('hh:mm A')
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    height:65vh;
  }
  ::v-deep .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%;
  }
  ::v-deep .theme--light.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before {
    border-image: none;
}
</style>
